// extracted by mini-css-extract-plugin
export default {"feedback-body":"FeedbackButton__feedback-body___1ALp2","feedbackButton":"FeedbackButton__feedbackButton___3Cl0E"};